import {FC} from 'react';
import {useField} from 'formik';
import {useTranslation} from 'react-i18next';
import StuckItemsList from './StuckItemsList';
import {ValidationError} from '../../../../../../common/formik/errors';
import {formatStuckItems} from './formatStuckItems';
import {EmployeeStuckItem} from '../../../../../types';

type StuckItemsProps = {
  stuckItems?: Nullable<EmployeeStuckItem[]>,
  name: string,
  disabled: boolean,
}

const StuckItems: FC<StuckItemsProps> = ({stuckItems, name, disabled}) => {
  const {t} = useTranslation('tasks');
  const [{}, {error, touched}, {}] = useField(name);

  if (!stuckItems?.length) {
    return null;
  }

  const {firstHalf, secondHalf} = formatStuckItems(stuckItems);

  return (
    <div>
      <h5 className="questionnaire__subtitle">
        {t('employeeSurvey.questionnaire.stuckItems.title')}
      </h5>

      <div className="stuck-items">
        {!!firstHalf.length && (
          <StuckItemsList
            name={name}
            items={firstHalf}
            disabled={disabled}
          />
        )}

        {!!secondHalf.length && (
          <StuckItemsList name={name} items={secondHalf} disabled={disabled} />
        )}
      </div>
      <div className="stuck-items__error">
        <ValidationError touched={touched} error={error} />
      </div>
    </div>
  );
};

export default StuckItems;
